/** The size mapping below is taken from legacy web and WorldNow.AdMan */
const AD_SIZE_MAPPING = {
  1: { width: 468, height: 60 },
  14: { width: 120, height: 600 },
  16: { width: 1, height: 1 },
  17: { width: 1, height: 1 },
  18: { width: 120, height: 240 },
  20: { width: 180, height: 150 },
  21: { width: 88, height: 31 },
  22: { width: 490, height: 25 },
  23: { width: 120, height: 240 },
  24: { width: 120, height: 15 },
  26: { width: 120, height: 60 },
  27: { width: 120, height: 60 },
  28: { width: 120, height: 60 },
  35: { width: 180, height: 150 },
  40: { width: 468, height: 60 },
  41: { width: 728, height: 90 },
  42: { width: 160, height: 600 },
  43: { width: 300, height: 250 },
  44: { width: 300, height: 75 },
  45: { width: 1, height: 1 },
  46: { width: 728, height: 90 },
  47: { width: 300, height: 150 },
  49: { width: 500, height: 300 },
  50: { width: 300, height: 175 },
  52: { width: 300, height: 250 },
  54: { width: 645, height: 300 },
  63: { width: 300, height: 600 },
  85: { width: 850, height: 30 },
  86: { width: 980, height: 30 },
  101: { width: 300, height: 150 },
  103: { width: 320, height: 250 },
  104: { width: 468, height: 60 },
  105: { width: 320, height: 50 },
  106: { width: 320, height: 50 }
};

const mapAdSizeById = (id) => {
  return AD_SIZE_MAPPING[id] || {};
};

export { mapAdSizeById };



// WEBPACK FOOTER //
// ./app/utils/AdUtils.js